import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../hooks/useTheme';
import Button from './ui/Button';
import { theme } from '../styles/design-system';
import { useNavigate } from 'react-router-dom';

const DesktopNavigation = () => {
  const location = useLocation();
  const { user, isAuthenticated, logout } = useAuth();
  const { theme: currentTheme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const isActive = (path) => location.pathname === path;

  const handleLoginClick = () => {
    navigate('/login');
  };

  const handleSignupClick = () => {
    navigate('/signup');
  };

  const navItems = [
    {
      path: '/chat',
      label: 'Chat',
      icon: '💬',
      active: isActive('/chat'),
    },

    {
      path: '/algo-runner',
      label: 'Algo Runner',
      icon: '🤖',
      active: isActive('/algo-runner'),
    },
    {
      path: '/fno-trading',
      label: 'F&O Trading',
      icon: '📈',
      active: isActive('/fno-trading'),
    },
    {
      path: '/voice-alerts',
      label: 'Voice Alerts',
      icon: '🎤',
      active: isActive('/voice-alerts'),
    },
    {
      path: '/ai-dashboard',
      label: 'AI Dashboard',
      icon: '🧠',
      active: isActive('/ai-dashboard'),
    },
    {
      path: '/revenue',
      label: 'Revenue',
      icon: '💰',
      active: isActive('/revenue'),
    },
  ];

  return (
    <header
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: `${theme.spacing[4]} ${theme.spacing[6]}`,
        backgroundColor: 'var(--header-bg)',
        borderBottom: '1px solid var(--header-border)',
        position: 'sticky',
        top: 0,
        zIndex: 40,
        backdropFilter: 'blur(10px)',
      }}
    >
      {/* Brand */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing[3],
        }}
      >
        <div
          style={{
            fontSize: theme.typography.fontSize['2xl'],
            fontWeight: theme.typography.fontWeight.extrabold,
            color: 'var(--text-primary)',
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing[2],
            letterSpacing: '-0.025em',
            textRendering: 'optimizeLegibility',
            WebkitFontSmoothing: 'antialiased',
            MozOsxFontSmoothing: 'grayscale',
          }}
        >
          🚀 AstroTrader AI
        </div>
      </div>

      {/* Navigation Links */}
      <nav
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing[1],
        }}
      >
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: theme.spacing[2],
              padding: `${theme.spacing[2]} ${theme.spacing[4]}`,
              borderRadius: theme.borderRadius.lg,
              textDecoration: 'none',
              color: item.active ? 'var(--nav-active-color)' : 'var(--nav-color)',
              backgroundColor: item.active ? 'var(--nav-active-bg)' : 'transparent',
              border: item.active ? '1px solid var(--nav-active-border)' : '1px solid transparent',
              transition: 'all 0.2s ease-in-out',
              fontWeight: item.active
                ? theme.typography.fontWeight.bold
                : theme.typography.fontWeight.semibold,
              fontSize: theme.typography.fontSize.sm,
              letterSpacing: '-0.01em',
            }}
          >
            <span style={{ fontSize: '16px' }}>{item.icon}</span>
            <span>{item.label}</span>
          </Link>
        ))}
      </nav>

      {/* Right Side Actions */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing[3],
        }}
      >
        {/* Theme Toggle */}
        <Button
          variant="ghost"
          size="sm"
          onClick={toggleTheme}
          icon={currentTheme === 'dark' ? '☀️' : '🌙'}
        />

        {/* User Section */}
        {isAuthenticated ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: theme.spacing[3],
            }}
          >
            <Link
              to="/profile"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: theme.spacing[2],
                padding: `${theme.spacing[2]} ${theme.spacing[3]}`,
                borderRadius: theme.borderRadius.lg,
                textDecoration: 'none',
                color: 'var(--text-primary)',
                backgroundColor: 'var(--profile-bg)',
                border: '1px solid var(--profile-border)',
                transition: 'all 0.2s ease-in-out',
              }}
            >
              <span style={{ fontSize: '16px' }}>👤</span>
              <span style={{
                fontWeight: theme.typography.fontWeight.semibold,
                fontSize: theme.typography.fontSize.sm,
                letterSpacing: '-0.01em',
              }}>
                {user?.username || 'Profile'}
              </span>
            </Link>

            <Button
              variant="danger"
              size="sm"
              onClick={logout}
              icon="🚪"
            >
              Logout
            </Button>
          </div>
        ) : (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: theme.spacing[2],
            }}
          >
            <Button
              variant="outline"
              size="sm"
              onClick={handleLoginClick}
            >
              Login
            </Button>
            <Button
              variant="primary"
              size="sm"
              onClick={handleSignupClick}
            >
              Sign Up
            </Button>
          </div>
        )}
      </div>

    </header>
  );
};

export default DesktopNavigation;
